import React from "react"
import Tags from "./Tags.js"
import useTags from "hooks/useTags"
import TagAdd from "./TagAdd.js"
import TagAssign from "./TagAssign"
import "./TagEditor.css"

export default function TagEditor() {

    const {tags, addTag, deleteTag, loadTags} = useTags()

    return <section id="tag-editor">
        <h3>Tagovi</h3>            
        <p>Spisak tagova koji se mogu dodeljivati korisnicima i beleškama</p>
        
        <Tags tags={tags} deleteTag={deleteTag} addTag={addTag}/>
        <TagAdd addTag={addTag}/>
        <hr/>  
        <TagAssign tags={tags}/>
    </section>
    
}
